import React from "react"
import { Typography } from "@material-ui/core"

import { EditableBlockDefaultProps } from "@/protocols/chatBotConstructor"

import BlockBodyItem from "@/pages/Admin/ChatBot/ChatBotConstructor/components/BlockBodyItem"
import BlockBodyItemTitle from "@/pages/Admin/ChatBot/ChatBotConstructor/components/BlockBodyItemTitle"
import BlockBodyContainer from "@/pages/Admin/ChatBot/ChatBotConstructor/components/BlockBodyContainer"
import BlockBodyItemInput from "@/pages/Admin/ChatBot/ChatBotConstructor/components/BlockBodyItemInput"
import BlockEditContainer from "@/pages/Admin/ChatBot/ChatBotConstructor/components/BlockEditContainer"
import BlockBodyEditMessageItem from "@/pages/Admin/ChatBot/ChatBotConstructor/components/BlockBodyEditMessageItem"

import AttendanceEditor from "@/pages/Admin/ChatBot/ChatBotConstructor/Blocks/AssignAttendanceBlock/AttendanceEditor"

import {
	getNextChatBotRuleDescription,
	getCurrentAssignAttendanceOption
} from "@/utils/chatBot"

const AssignAttendanceBlock: React.FC<EditableBlockDefaultProps> = (props) => {
	const {
		changeChatBotFlowContent,
		chatBotFlowBlockContent,
		nextChatBotFlowBlockRules,
		constructionResources,
		flowBlock,
		deleteChatBotFlowBlock
	} = props

	const handleChangeAttendance = () => {
		AttendanceEditor.open({
			onSave: (chatBotFlowBlockContent) => changeChatBotFlowContent(chatBotFlowBlockContent),
			chatBotFlowBlockContent,
			constructionResources
		})
	}

	const getAssignAttendanceQueueTitle = () => {
		const option = getCurrentAssignAttendanceOption(constructionResources, chatBotFlowBlockContent)

		if (!option) {
			return ""
		}

		if (option.assignmentQueueType === "Team") {
			return `Equipe: ${option?.name}`
		} else if (option.assignmentQueueType === "User") {
			return `Atendente: ${option?.name}`
		} else {
			return `${option?.title}: ${option?.name}`
		}
	}

	return (
		<BlockEditContainer
			name={flowBlock.title}
			onDelete={deleteChatBotFlowBlock}
		>
			<BlockBodyContainer>
				<BlockBodyEditMessageItem
					constructionResources={constructionResources}
					title="Mensagem"
					onSave={(buildedMessages) => changeChatBotFlowContent({ messagesToSend: buildedMessages })}
					messages={chatBotFlowBlockContent.messagesToSend}
				/>

				<BlockBodyItem>
					<BlockBodyItemTitle
						title="Direcionar para"
					/>

					<BlockBodyItemInput
						text={getAssignAttendanceQueueTitle() || ""}
						type="action"
						placeholder="Selecione uma equipe ou um atendente"
						onEdit={handleChangeAttendance}
					/>
				</BlockBodyItem>

				<BlockBodyItem>
					<BlockBodyItemTitle
						title="Condição de saída"
					/>

					{nextChatBotFlowBlockRules
						.map((nextChatBotFlowBlockRule) => (
							<Typography
								key={nextChatBotFlowBlockRule.id}
								variant="overline"
								color="textPrimary"
							>
								{getNextChatBotRuleDescription(nextChatBotFlowBlockRule)}
							</Typography>
						))
					}
				</BlockBodyItem>
			</BlockBodyContainer>
		</BlockEditContainer>
	)
}

export default AssignAttendanceBlock
